module.exports = __webpack_public_path__ + "media/images/home/main/aa/9-bb2d51d14fcb4e1d7c791db816bf653b.png";